import React from "react";
import { ButtonProps, ButtonRenderProps, ContentSection } from "sprint-common-web";

import {
    DistributionListsDataContent,
    DistributionListsDataProvider
} from "../../common/data/lookup-data-providers/DistributionListsDataProvider";
import { AddDeliveryEndpointButton } from "./create/smartjog/create/AddSmartjogDeliveryEndpointButton";
import { DeliveryEndpointListing } from "./listing/DeliveryEndpointListing";

export const DeliveryEndpointSection: React.VFC = () => {
    const addDeliveryEndpointButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddDeliveryEndpointButton
    };

    return (
        <DistributionListsDataProvider>
            <DistributionListsDataContent.Consumer>
                {(context) => (
                    <ContentSection
                        header={"Delivery Endpoints"}
                        buttons={[addDeliveryEndpointButtonProps]}
                        isLoading={context.isLoading}
                    >
                        <DeliveryEndpointListing />
                    </ContentSection>
                )}
            </DistributionListsDataContent.Consumer>
        </DistributionListsDataProvider>
    );
};
